import { LIST_GC_TIME_MS, LIST_STALE_TIME_MS, useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { PaginatedResponse } from '@klareospace/pharos-lib-types';
import type { SiteWithSpaceName } from '@klareospace/pharos-lib-types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { createSiteApi, siteKeys } from '../api';
import type { SearchSitesParams } from '../api';

export interface UseSitesOptions extends SearchSitesParams {
  enabled?: boolean;
}

export function useSites(params: UseSitesOptions): UseQueryResult<PaginatedResponse<SiteWithSpaceName>> {
  const { enabled = true, ...searchParams } = params;
  const client = useApiClient('admin-auth');
  const api = createSiteApi(client);

  return useQuery({
    enabled,
    gcTime: LIST_GC_TIME_MS,
    queryFn: () => api.searchSites(searchParams),
    queryKey: siteKeys.search(searchParams as Record<string, unknown>),
    staleTime: LIST_STALE_TIME_MS,
  });
}
